import React from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import { ROUTES } from 'shared/config/routes'
import { noteTakerStore } from 'shared/stores/noteTakerStore'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import { ReactComponent as MagicIcon } from 'assets/icons/magic.svg'
import { ReactComponent as ProfileIcon } from 'assets/icons/person.svg'
import s from '../NoteTakerDrawer.module.scss'

const SessionDrawerHeader = observer(({ studentName, studentGrade, topic }) => {
	const navigate = useNavigate()
	const studentId = noteTakerStore.activeNoteStudentId || noteTakerStore.sessionNote?.studentId

	const handleViewProfile = () => {
		if (!studentId) return
		if (noteTakerStore.hasUnsavedSummary) {
			noteTakerStore.requestCloseDrawer()
			return
		}
		if (!noteTakerStore.requestCloseDrawer()) return
		navigate(`${ROUTES.STUDENT_PROFILE}/${encodeURIComponent(studentId)}`)
	}

	return (
		<header className={s.topBar}>
			<div className={s.topBarInner}>
				<div className={s.headerStudent}>
					<InitialAvatar
						name={studentName}
						size={40}
						studentId={studentId}
						onClick={studentId ? handleViewProfile : undefined}
					/>
					<div>
						{studentId ? (
							<button
								type="button"
								className={s.headerStudentName}
								onClick={handleViewProfile}
							>
								{studentName}
							</button>
						) : (
							<div className={s.headerStudentName}>{studentName}</div>
						)}
						<div className={s.headerStudentMeta}>
							{studentGrade} &middot; {topic}
						</div>
					</div>
				</div>
				<div className={s.topActions}>
					<button
						type="button"
						className={s.ghostButton}
						onClick={handleViewProfile}
						disabled={!studentId}
					>
						<ProfileIcon />
						View profile
					</button>
					<button
						type="button"
						className={[s.ghostButton, s.ghostButtonAi].join(' ')}
						disabled
						title="Coming soon"
					>
						<MagicIcon />
						Edit with AI
					</button>
					<button
						type="button"
						className={s.iconOnlyButton}
						aria-label="Close session drawer"
						onClick={() => noteTakerStore.requestCloseDrawer()}
					>
						<CrossIcon />
					</button>
				</div>
			</div>
		</header>
	)
})

export default SessionDrawerHeader
